import React, { useEffect } from "react";
import styles from "./EmailSetup.module.css";
import { useDispatch, useSelector } from "react-redux";
import { emailSetupActions } from "@_actions/email_setup.actions";
import { catchError } from "@_utils/helpers";

import EmailIcon from "@mui/icons-material/Email";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SmtpSetup from "@_components/SmtpSetup/SmtpSetup";
import AppSnackbar from "@_components/AppSnackbar/AppSnackbar";
import { useSnackbar } from "@_hooks/useSnackbar";
import Scrollbar from "react-perfect-scrollbar-z";
import "scrollbar.css";
import { sidebarActions } from "@_actions/sidebar.actions";
import { sidebarConstants } from "@_constants/sidebar.constants";

function EmailSetup() {
  const dispatch = useDispatch();

  const emailSetupReducer = useSelector((state) => state.emailSetupReducer);

  const { snackbarProps, showSnackbarSuccess, showSnackbarError } = useSnackbar();

  useEffect(() => {
    dispatch(sidebarActions.updateStatus(sidebarConstants.EMAIL_SETUP));
  }, [dispatch]);

  const handleSmtpErrors = (message) => {
    showSnackbarError(message, { autoHideDuration: 7000 });
  };

  // display email setup PUT success & error
  useEffect(() => {
    if (emailSetupReducer.status.EMAIL_SETUP_PUT === "success") {
      showSnackbarSuccess("Success!");

      dispatch(emailSetupActions.clearStatusMessage("EMAIL_SETUP_PUT"));
    } else if (catchError(emailSetupReducer.status.EMAIL_SETUP_PUT)) {
      if (
        emailSetupReducer.status.EMAIL_SETUP_PUT ===
        "Expected type integer but found type null"
      ) {
        showSnackbarError("Please enter a valid port.", { autoHideDuration: 7000 });
      } else {
        showSnackbarError(emailSetupReducer.status.EMAIL_SETUP_PUT, {
          autoHideDuration: 7000,
        });
      }
      dispatch(emailSetupActions.clearStatusMessage("EMAIL_SETUP_PUT"));
    } else return;
  }, [dispatch, emailSetupReducer.status, showSnackbarError, showSnackbarSuccess]);

  // display email setup activation PUT success & error
  useEffect(() => {
    if (emailSetupReducer.status.EMAIL_SETUP_ACTIVATION_PUT === "success") {
      showSnackbarSuccess("Success!");
      dispatch(
        emailSetupActions.clearStatusMessage("EMAIL_SETUP_ACTIVATION_PUT"),
      );
    } else if (
      catchError(emailSetupReducer.status.EMAIL_SETUP_ACTIVATION_PUT)
    ) {
      showSnackbarError(emailSetupReducer.status.EMAIL_SETUP_ACTIVATION_PUT, {
        autoHideDuration: 7000,
      });
      dispatch(
        emailSetupActions.clearStatusMessage("EMAIL_SETUP_ACTIVATION_PUT"),
      );
    } else return;
  }, [dispatch, emailSetupReducer.status, showSnackbarError, showSnackbarSuccess]);

  useEffect(() => {
    if (emailSetupReducer.status.EMAIL_SENDER_NAME_PUT === "success") {
      showSnackbarSuccess("Email sender name updated successfully!");
      dispatch(emailSetupActions.clearStatusMessage("EMAIL_SENDER_NAME_PUT"));
    } else if (catchError(emailSetupReducer.status.EMAIL_SENDER_NAME_PUT)) {
      showSnackbarError(emailSetupReducer.status.EMAIL_SENDER_NAME_PUT, {
        autoHideDuration: 7000,
      });
      dispatch(emailSetupActions.clearStatusMessage("EMAIL_SENDER_NAME_PUT"));
    } else return;
  }, [dispatch, emailSetupReducer.status, showSnackbarError, showSnackbarSuccess]);

  return (
    <div className={styles.root}>
      <AppSnackbar {...snackbarProps} />

      <Scrollbar maxHeight="calc(100vh - 141px)">
        <div style={{ marginRight: 20 }}>
          <div className={styles.email_setup_header}>
            <div className={styles.settlement_portal_title}>
              <EmailIcon className={styles.email_icon} />
              <h2>Email</h2>
              <ArrowForwardIosIcon
                fontSize="small"
                className={styles.arrow_icon}
              />
              <h2>Setup</h2>
            </div>
            <p className={styles.email_setup_description}>
              Configure how you want to send emails with Fair Licensing. Emails
              in Fair Licensing are always sent from your own email address.
            </p>
          </div>

          <SmtpSetup onError={handleSmtpErrors} />
        </div>
      </Scrollbar>
    </div>
  );
}

export default EmailSetup;
